import React, { useCallback } from 'react';

import { asDraggableContentListItem, useSortableListItem } from '../../../_lib/components/SortableContentList';
import { LatestForumPostsEditableElement } from '../LatestForumPostsTypes';
import { StatusInfoError } from '../../../_lib/components/StatusInfo';
import {
  ContainerWithCommonContextMenu,
} from '../../../_lib/components/ContextMenu';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { SonForm } from '../../../_lib/Form2';
import { ContextMenuButtonProps } from '../../../_lib/components/ContextMenu/partials/ContextMenuButton';

type LatestForumPostsListItemProps = LatestForumPostsEditableElement & {
  openDeleteForm?: (form: SonForm<any>) => void;
};

function LatestForumPostsListItem(props: LatestForumPostsListItemProps) {
  const { t } = useSonTranslation('LatestForumPosts');

  const { id, forumTitle, delete: deleteForm, openDeleteForm } = props;

  const { move, nextItemId, prevItemId, error } = useSortableListItem(id);

  const moveElementUp = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (prevItemId) {
        event.preventDefault();
        event.stopPropagation();

        move(prevItemId);
      }
    }, [move, prevItemId]);

  const moveElementDown = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    if (nextItemId) {
      event.preventDefault();
      event.stopPropagation();

      move(nextItemId);
    }
  }, [move, nextItemId]);

  const contextMenuActions: ContextMenuButtonProps[] = [
    ...openDeleteForm
      ? [{
          children: t('removeForum'),
          key: t('removeForum'),
          name: 'removeForm',
          // 'aria-haspopup': true,
          onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();

            openDeleteForm(deleteForm);
          },
        }] as ContextMenuButtonProps[]
      : [],
    {
      children: t('moveUp'),
      key: 'moveElementUp',
      disabled: !prevItemId,
      onClick: moveElementUp,
    },
    {
      children: t('moveDown'),
      key: 'moveElementDown',
      disabled: !nextItemId,
      onClick: moveElementDown,
    },
  ];

  return (
    <>
      <ContainerWithCommonContextMenu
        toolTip={t('manageForum', { name: forumTitle })}
        toolTipPlacement={TooltipPlacement.TOP}
        actions={contextMenuActions}
      >
        <p>{forumTitle}</p>
      </ContainerWithCommonContextMenu>
      {error && <StatusInfoError message={t('errorResponse')} modifier="padding-top" />}
    </>
  );
}

export const DraggableLatestForumPostListItem = asDraggableContentListItem(LatestForumPostsListItem);
